import { ReactNode } from 'react';

interface Props {
  children?: ReactNode;
  index: number;
  value: number;
}

export function TabPanel({ value, index, children }: Props): JSX.Element {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && children}
    </div>
  );
}
